module.exports = __webpack_public_path__ + "static/media/markdown_editor.3c247563.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/swipe/markdown_editor.jpg
// module id = 257
// module chunks = 0